import React from "react";

// import data from "./data"
import Service from "./service";
import "./style.scss";

const ServiceList = ({ data, parentCategory, blockMode }) => (
  <div class="services-list">
    {data.map((item) => (
      <Service
        {...item}
        parentCategory={parentCategory}
        blockMode={blockMode}
      />
    ))}
  </div>
);

export default ServiceList;
